import React, { createContext, useMemo } from 'react';
/**
 * Context that allows to share common Badge Preview logic
 *
 * * usage is optional
 */
export const BadgePreviewContext = createContext({});
/**
 * Context that allows to share common Badge Preview logic
 *
 * * usage is optional
 */
export const BadgePreviewContextProvider = ({ children, onGetTemplateDataForBadgeClassifierImageGeneration, defaultSampleAccountData, defaultFormSettings, }) => {
    const state = useMemo(() => ({
        onGetTemplateDataForBadgeClassifierImageGeneration: onGetTemplateDataForBadgeClassifierImageGeneration,
        defaultSampleAccountData,
        defaultFormSettings,
    }), [onGetTemplateDataForBadgeClassifierImageGeneration, defaultFormSettings, defaultSampleAccountData]);
    return React.createElement(BadgePreviewContext.Provider, { value: state }, children);
};
